/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Handover_Item_4Inputs */

const en_how_we_work_handover_item_4 = /** @type {(inputs: How_We_Work_Handover_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership and support agreed`)
};

const lv_how_we_work_handover_item_4 = /** @type {(inputs: How_We_Work_Handover_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saskaņota atbildība un atbalsts`)
};

/**
* | output |
* | --- |
* | "Ownership and support agreed" |
*
* @param {How_We_Work_Handover_Item_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_handover_item_4 = /** @type {((inputs?: How_We_Work_Handover_Item_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Handover_Item_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_handover_item_4(inputs)
	return en_how_we_work_handover_item_4(inputs)
});